import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import { SwatchGroup, Swatch } from '../components';
import { Theme } from '../constants';

const ThemeSelector = ({ theme, selectTheme, selectedTheme }) => (
  <ThemeProvider theme={theme}>
    <div>
      <SwatchGroup name="theme" selectedTheme={selectedTheme} selectTheme={selectTheme}>
        <Swatch value="dark" bg={Theme.dark.bg} title="Dark" />
        <Swatch value="dracula" bg={Theme.dracula.bg} title="Dracula" />
        <Swatch value="light" bg={Theme.light.bg} title="Light" />
        <Swatch value="bright" bg={Theme.bright.bg} title="Bright" />
      </SwatchGroup>
    </div>
  </ThemeProvider>
);

export default withTheme(ThemeSelector);



// WEBPACK FOOTER //
// ./src/components/ThemeSelector.js